import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  zh: {
    translation: {
      "purchaseHistory.title": "购买历史",
      "order.totalPrice": "合计金额: {{amount}} 日元",
      "order.orderId": "注文ID: {{id}}",
      "searchTennis.title": "东京都网球场预约信息",
      "searchTennis.placeholderStart": "开始日",
      "searchTennis.placeholderEnd": "结束日",
      "searchTennis.filter.all": "全部显示",
      "searchTennis.filter.weekend": "含有周末",
      "searchTennis.filter.nonWeekend": "不含周末",
      "searchTennis.loading": "数据获取中",
      "tennisUser.profileSettings": "个人信息设置",
      "tennisUser.tennisOrderCheck": "网球订单管理",
      "tennisUser.tennisPurchaseHistory": "网球购买历史",
      "tennisUser.permissionManagement": "权限管理",
      "tennisUser.logout": "登出",
      "tennisUser.logoutSuccess": "已成功登出",
      "searchTennis.hintViewAvailable": "点击此处查看可购买的周末场地",
      "auction.menuTitle": "拍卖 - 预约场地交易",
      "auction.loading": "加载中...",
      "auction.noAvailable": "当前没有可交易的预约场地。",
      "auction.sellerLabel": "出品者",
      "auction.statusLabel": "订单状态",
      "auction.status.active": "出售中",
      "auction.status.sold": "已售出",
      "auction.status.cancelled": "已取消",
      "auction.loadPaypaySuccess": "已读取已有的 PayPay 账号",
      "auction.loadPaypayFailed": "PayPay 账号读取失败，请手动输入",
      "auction.modalOkInput": "输入完成",
      "auction.loginRequired": "需要登录",
      "auction.noRecipientEmail": "没有收件人邮箱地址",
      "auction.createOrderFailed": "订单创建失败，请重试",
      "auction.paymentMailSent": "已发送付款通知邮件",
      "auction.paymentMailFailed": "发送付款确认邮件失败",
      "auction.fetchQrFailed": "获取支付二维码失败",
      "auction.modalPaymentTitle": "支付（PayPay）",
      "auction.modalOkPaid": "已付款",
      "auction.modalCancel": "关闭",
      "auction.qrMissing": "没有可用的支付二维码",
      "auction.payAfterClick": "使用 PayPay 支付后，请点击「已付款」。",
      "auction.enterPaypayAccount": "请输入 PayPay 账号名",
      "auction.paypayPlaceholder": "PayPay 账号名（例: example@domain）",
      "auction.buyOneClick": "一键购买",
      "tennisOrder.header": "订单管理",
      "tennisOrder.noHistory": "过去的购买记录为空",
      "tennisOrder.orderNumber": "订单编号",
      "tennisOrder.orderId": "订单ID",
      "tennisOrder.court": "球场",
      "tennisOrder.dateTime": "日期·时间带",
      "tennisOrder.paypayAccount": "PayPay 账号",
      "tennisOrder.buyerEmail": "购买者邮箱",
      "tennisOrder.paymentConfirmedAt": "支付确认时间",
      "tennisOrder.orderCreatedAt": "订单创建时间",
      "tennisOrder.auctionPrice": "拍卖价格",
      "tennisOrder.auctionStatus": "拍卖状态",
      "tennisOrder.buyerName": "购买者姓名",
      "tennisOrder.buyerPhone": "购买者电话号码",
      "tennisOrder.buyerMailAddress": "购买者邮箱地址",
      "tennisOrder.buyerPaypayAccount": "购买者 PayPay 账号",
      "tennisOrder.new": "New",
      "order.confirmTitle": "确认",
      "order.confirmContent": "确定将状态改为「{{status}}」吗？",
      "order.okText": "确认",
      "order.cancelText": "取消",
      "order.missingOrder": "缺少订单信息",
      "order.sendSuccess": "发送成功，已更新订单状态",
      "order.sendSuccessButUpdateFailed": "发送成功，但更新订单状态失败（请稍后重试）",
      "order.sendFailed": "发送失败",
      "order.sendReservationEmail": "发送预约信息邮件",
      "status.NotSent": "未发送",
      "status.Queued": "排队中",
      "status.Sent": "已发送",
      "status.Failed": "发送失败",

      // ...按需补充键
    }
  },
  ja: {
    translation: {
      "purchaseHistory.title": "購入履歴",
      "order.totalPrice": "合計金額: {{amount}} 円",
      "order.orderId": "注文ID: {{id}}",
      "searchTennis.title": "東京都テニスコート予約情報",
      "searchTennis.placeholderStart": "開始日",
      "searchTennis.placeholderEnd": "終了日",
      "searchTennis.filter.all": "すべて表示",
      "searchTennis.filter.weekend": "週末あり",
      "searchTennis.filter.nonWeekend": "週末なし",
      "searchTennis.loading": "データ取得中",
      "tennisUser.profileSettings": "個人情報設定",
      "tennisUser.tennisOrderCheck": "コート注文管理",
      "tennisUser.tennisPurchaseHistory": "コート購入履歴",
      "tennisUser.permissionManagement": "権限管理",
      "tennisUser.logout": "ログアウト",
      "tennisUser.logoutSuccess": "ログアウト完了",
      "searchTennis.hintViewAvailable": "週末に購入可能なコートを見るにはここをクリックしてください",
      "auction.menuTitle": "オークション - 予約済みコートの取引",
      "auction.loading": "読み込み中...",
      "auction.noAvailable": "現在取引可能な予約コートはありません。",
      "auction.sellerLabel": "出品者",
      "auction.statusLabel": "ステータス",
      "auction.status.active": "販売中",
      "auction.status.sold": "販売済み",
      "auction.status.cancelled": "キャンセル済み",
      "auction.loadPaypaySuccess": "既存の PayPay アカウントを読み込みました",
      "auction.loadPaypayFailed": "PayPay アカウントの読み込みに失敗しました。手動で入力してください。",
      "auction.modalOkInput": "入力済み",
      "auction.loginRequired": "ログインが必要です",
      "auction.noRecipientEmail": "送信先メールアドレスがありません。",
      "auction.createOrderFailed": "注文の作成に失敗しました。もう一度お試しください。",
      "auction.paymentMailSent": "支払い通知メールを送信しました",
      "auction.paymentMailFailed": "支払い確認メールの送信に失敗しました",
      "auction.fetchQrFailed": "支払い用QRの取得に失敗しました",
      "auction.modalPaymentTitle": "支払い（PayPay）",
      "auction.modalOkPaid": "支払済み (已付款)",
      "auction.modalCancel": "閉じる",
      "auction.qrMissing": "支払い用QRがありません",
      "auction.payAfterClick": "PayPayで支払い後、「支払済み」を押してください。",
      "auction.enterPaypayAccount": "PayPayアカウント名を入力してください",
      "auction.paypayPlaceholder": "PayPayアカウント名（例: example@domain）",
      "auction.buyOneClick": "ワンクリックで購入",
      "tennisOrder.header": "注文管理",
      "tennisOrder.noHistory": "過去の購入履歴がありません",
      "tennisOrder.orderNumber": "注文番号",
      "tennisOrder.orderId": "注文ID",
      "tennisOrder.court": "コート",
      "tennisOrder.dateTime": "日付・時間",
      "tennisOrder.paypayAccount": "PayPay アカウント",
      "tennisOrder.buyerEmail": "購入者メール",
      "tennisOrder.paymentConfirmedAt": "支払確認日時",
      "tennisOrder.orderCreatedAt": "注文作成日時",
      "tennisOrder.auctionPrice": "オークション価格",
      "tennisOrder.auctionStatus": "オークションステータス",
      "tennisOrder.buyerName": "購入者名",
      "tennisOrder.buyerPhone": "購入者電話番号",
      "tennisOrder.buyerMailAddress": "購入者メール",
      "tennisOrder.buyerPaypayAccount": "購入者 PayPay アカウント",
      "tennisOrder.new": "New",
      "order.confirmTitle": "確認",
      "order.confirmContent": "ステータスを「{{status}}」に変更しますか？",
      "order.okText": "確認",
      "order.cancelText": "キャンセル",
      "order.missingOrder": "注文情報が不足しています",
      "order.sendSuccess": "送信に成功し、注文ステータスを更新しました",
      "order.sendSuccessButUpdateFailed": "送信に成功しましたが、注文ステータスの更新に失敗しました（後で再試行してください）",
      "order.sendFailed": "送信に失敗しました",
      "order.sendReservationEmail": "予約情報メールを送信する",
      "status.NotSent": "未送信",
      "status.Queued": "キュー中",
      "status.Sent": "送信済み",
      "status.Failed": "送信失敗",
      // ...按需补充键
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'ja', // 默认语言
  fallbackLng: 'ja',
  interpolation: { escapeValue: false },
});

export default i18n;